import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import PrivateRoute from "./components/PrivateRoute";
import AddComputer from "./pages/AddComputer";
import AddShare from "./pages/AddShare";
import Backups from "./pages/Backups";
import AddPrinter from "./pages/AddPrinter";
import ComputerDetail from "./pages/ComputerDetail";
import AdminSupport from "./pages/AdminSupport";
import ApprovePC from "./pages/ApprovePC";
import ConnectPC from "./pages/ConnectPC";
import Dashboard from "./pages/Dashboard";
import ForgotPassword from "./pages/ForgotPassword";
import InstallerAdmin from "./pages/InstallerAdmin";
import Join from "./pages/Join";
import Login from "./pages/Login";
import MfaChallenge from "./pages/MfaChallenge";
import FixedAddressesPage from "./pages/FixedAddresses";
import ServerUpdatePage from "./pages/ServerUpdate";
import MyComputers from "./pages/MyComputers";
import PrinterSharing from "./pages/PrinterSharing";
import OfficeFiles from "./pages/OfficeFiles";
import Scanners from "./pages/Scanners";
import ResetPassword from "./pages/ResetPassword";
import SendFile from "./pages/SendFile";
import Sharing from "./pages/Sharing";
import Signup from "./pages/Signup";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/signup" element={<Signup />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/mfa/challenge" element={<MfaChallenge />} />
        {/* PC enrollment: /join is anonymous (the PC visits it),
            /approve/<code> requires owner auth (the phone uses it).
            Both belong to the new onboarding flow; see STATUS.md. */}
        <Route path="/join" element={<Join />} />
        <Route path="/approve/:code" element={<ApprovePC />} />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/computers"
          element={
            <PrivateRoute>
              <MyComputers />
            </PrivateRoute>
          }
        />
        <Route
          path="/computers/add"
          element={
            <PrivateRoute>
              <AddComputer />
            </PrivateRoute>
          }
        />
        <Route
          path="/computers/:agentId/add-printer"
          element={
            <PrivateRoute>
              <AddPrinter />
            </PrivateRoute>
          }
        />
        <Route
          path="/computers/:agentId"
          element={
            <PrivateRoute>
              <ComputerDetail />
            </PrivateRoute>
          }
        />
        <Route path="/sharing" element={<Navigate to="/sharing/folders" replace />} />
        <Route
          path="/sharing/folders"
          element={
            <PrivateRoute>
              <Sharing />
            </PrivateRoute>
          }
        />
        <Route
          path="/sharing/printers"
          element={
            <PrivateRoute>
              <PrinterSharing />
            </PrivateRoute>
          }
        />
        <Route
          path="/fixed-addresses"
          element={
            <PrivateRoute>
              <FixedAddressesPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/update"
          element={
            <PrivateRoute>
              <ServerUpdatePage />
            </PrivateRoute>
          }
        />
        <Route
          path="/sharing/office-files"
          element={
            <PrivateRoute>
              <OfficeFiles />
            </PrivateRoute>
          }
        />
        <Route
          path="/sharing/scanners"
          element={
            <PrivateRoute>
              <Scanners />
            </PrivateRoute>
          }
        />
        <Route
          path="/sharing/add"
          element={
            <PrivateRoute>
              <AddShare />
            </PrivateRoute>
          }
        />
        <Route
          path="/sharing/send"
          element={
            <PrivateRoute>
              <SendFile />
            </PrivateRoute>
          }
        />
        <Route
          path="/backups"
          element={
            <PrivateRoute>
              <Backups />
            </PrivateRoute>
          }
        />
        <Route
          path="/connect/:code"
          element={
            <PrivateRoute>
              <ConnectPC />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/installer"
          element={
            <PrivateRoute>
              <InstallerAdmin />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/support"
          element={
            <PrivateRoute>
              <AdminSupport />
            </PrivateRoute>
          }
        />
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
